module.exports = __webpack_public_path__ + "img/traffic-sign-2.f8ac6921.png";